export function applyForceLightTheme() {
  const html = document.documentElement
  const body = document.body

  html.classList.remove('dark', 'p-dark')
  body.classList.remove('dark', 'p-dark')
  html.style.colorScheme = 'light'
  html.setAttribute('data-p-theme', 'light')
}

export function initForceLightTheme() {
  applyForceLightTheme()

  const observer = new MutationObserver(() => {
    const html = document.documentElement
    const body = document.body
    if (
      html.classList.contains('dark') ||
      html.classList.contains('p-dark') ||
      body.classList.contains('dark') ||
      body.classList.contains('p-dark') ||
      html.getAttribute('data-p-theme') === 'dark'
    ) {
      applyForceLightTheme()
    }
  })

  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class', 'data-p-theme']
  })
  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['class']
  })

  return observer
}
